export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/c149c2995e67c98d8198109bf15793c7.svg";